/* 필요 파일 import
import { $DKD, $GCD, $CD } from '@/confs/common.const';
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";
*/

export default {
    state: {
        simpleMap: undefined,
        simpleMaps: undefined,
        marker: undefined,
    },
    getters: {
        getSimpleMap: function(state) {
            return state.simpleMap;
        },
        getSimpleMaps: function(state) {
            return state.simpleMaps;
        },
        getMarker: function(state) {
            return state.marker;
        },
    },
    mutations: {
        SIMPLE_MAP: function(state, simpleMap) {
            state.simpleMap = simpleMap;
        },
        SIMPLE_MAPS: function(state, simpleMaps) {
            state.simpleMaps = simpleMaps;
        },
        SELECTED_MARKER: function(state, marker) {
            state.marker = marker;
        },
    },
    actions: {
        SET_SIMPLE_MAP: function(context, simpleMap) {
            context.commit("SIMPLE_MAP", simpleMap);
        },
        SET_SIMPLE_MAPS: function(context, simpleMaps) {
            context.commit("SIMPLE_MAPS", simpleMaps);
        },
        SET_SELECTED_MARKER: function(context, marker) {
            context.commit("SELECTED_MARKER", marker);
        },
    }
};
